import { RenderComponentStrategy } from './render-component.strategy';

export class Shelf extends RenderComponentStrategy {
	componentKey = 'Shelf';
}
